"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSellwildWidget = exports.isNewslettersWidget = exports.isFallbackVideoWidget = exports.isInContentAdWidget = exports.isKeystoneWidget = exports.isSpotWidget = void 0;
const isSpotWidget = (w) => w.widgetType === 'Spot';
exports.isSpotWidget = isSpotWidget;
const isKeystoneWidget = (w) => w.widgetType === 'Keystone';
exports.isKeystoneWidget = isKeystoneWidget;
const isInContentAdWidget = (w) => w.widgetType === 'InContentAd';
exports.isInContentAdWidget = isInContentAdWidget;
const isFallbackVideoWidget = (w) => w.widgetType === 'FallbackVideo';
exports.isFallbackVideoWidget = isFallbackVideoWidget;
const isNewslettersWidget = (w) => w.widgetType === 'Newsletters';
exports.isNewslettersWidget = isNewslettersWidget;
const isSellwildWidget = (w) => w.widgetType === 'Sellwild';
exports.isSellwildWidget = isSellwildWidget;
//# sourceMappingURL=typeGuards.js.map